import script from "./SettingsBrowserContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsBrowserContent.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsBrowserContent.vue?vue&type=style&index=0&id=bb323b5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb323b5a"]])

export default __exports__